import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.jsx";
import { Badge } from "@/components/ui/badge.jsx";
import {
  AlertTriangle,
  User,
  Building2,
  CheckCircle,
  XCircle,
} from "lucide-react";

const mockDirectorsData = [
  {
    nom: "Pierre Martin",
    fonction: "Gérant",
    societes: [
      {
        nom: "SOLUTIONS DIGITALES PRO SARL",
        siren: "891 234 567",
      },
      {
        nom: "TECH INNOVATIONS SAS",
        siren: "823 456 789",
        procedure: {
          type: "Liquidation judiciaire",
          date: "15/03/2021",
          statut: "Clôturée",
        },
      },
    ],
  },
  {
    nom: "Sophie Dubois",
    fonction: "Directrice Administrative",
    societes: [
      {
        nom: "SOLUTIONS DIGITALES PRO SARL",
        siren: "891 234 567",
      },
      {
        nom: "CONSEIL STRATEGIE PLUS",
        siren: "765 432 198",
      },
    ],
  },
];

export function CollectiveProcedures() {
  const hasProcedures = mockDirectorsData.some((director) =>
    director.societes.some((societe) => societe.procedure),
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-lg financial-gradient flex items-center justify-center">
          <AlertTriangle className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            Procédures Collectives
          </h1>
          <p className="text-muted-foreground">
            Vérification des procédures sur l'entreprise et les dirigeants
          </p>
        </div>
      </div>

      <Card className="financial-card">
        <CardHeader>
          <CardTitle className="text-xl text-card-foreground flex items-center space-x-2">
            <AlertTriangle className="w-5 h-5 text-primary" />
            <span>Statut des Procédures</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {hasProcedures && (
            <div className="p-4 rounded-lg bg-destructive/10 border border-destructive/20">
              <div className="flex items-start space-x-3">
                <AlertTriangle className="w-5 h-5 text-destructive mt-0.5" />
                <div>
                  <p className="font-medium text-destructive">
                    Points d'attention
                  </p>
                  <p className="text-sm text-destructive/80 mt-1">
                    Une procédure collective passée a été identifiée sur le
                    dirigeant Pierre Martin dans la société TECH INNOVATIONS SAS
                    (liquidation judiciaire clôturée en 2021).
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-card-foreground">
              Dirigeants et Sociétés Associées
            </h3>

            {mockDirectorsData.map((director, index) => (
              <div
                key={index}
                className="border border-border/50 rounded-lg p-4 space-y-4"
              >
                <div className="flex items-center space-x-3">
                  <User className="w-5 h-5 text-primary" />
                  <div>
                    <h4 className="font-semibold text-card-foreground">
                      {director.nom}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {director.fonction}
                    </p>
                  </div>
                </div>

                <div className="space-y-3 pl-8">
                  {director.societes.map((societe, socIndex) => (
                    <div
                      key={socIndex}
                      className="flex items-start justify-between p-3 rounded-md bg-muted/30"
                    >
                      <div className="flex items-start space-x-3 flex-1">
                        <Building2 className="w-4 h-4 text-primary mt-0.5" />
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-card-foreground">
                            {societe.nom}
                          </p>
                          <p className="text-xs text-muted-foreground font-mono">
                            SIREN: {societe.siren}
                          </p>
                        </div>
                      </div>

                      <div className="flex-shrink-0">
                        {societe.procedure ? (
                          <div className="space-y-1">
                            <Badge variant="destructive" className="text-xs">
                              {societe.procedure.type}
                            </Badge>
                            <div className="text-xs text-muted-foreground text-right">
                              <div>{societe.procedure.date}</div>
                              <div className="font-medium">
                                {societe.procedure.statut}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Badge variant="outline" className="text-xs">
                            Aucune procédure
                          </Badge>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
